export class BaseField {
  constructor(config = {}) {
    this.key = config.key;
    this.icon = config.icon;
    this.defaultLabel = config.defaultLabel;
  }

  /**
   * Render field for listing card
   * @param {Object} property - Property object
   * @returns {{ label: string, value: string|number }}
   */
  renderForList(property, params = {}) {
    throw new Error('renderForList must be implemented');
  }

  /**
   * Render field for detail card
   * @param {Object} property - Property object
   * @param {Object} params - Optional overrides (e.g. { label: 'Custom label' })
   * @returns {{ label: string, value: string|number }}
   */
  renderForCard(property, params = {}) {
    throw new Error('renderForCard must be implemented');
  }
}
